import { render, staticRenderFns } from "./newsletter-signup.vue?vue&type=template&id=09a33387&scoped=true&lang=pug&"
import script from "./newsletter-signup.vue?vue&type=script&lang=js&"
export * from "./newsletter-signup.vue?vue&type=script&lang=js&"
import style0 from "./newsletter-signup.vue?vue&type=style&index=0&id=09a33387&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a33387",
  null
  
)

/* custom blocks */
import block0 from "./newsletter-signup.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports